export const isEventLocked = (event) => {
    
    if(event.lockDate && new Date(event.lockDate) < new Date){
        return true
    }
    return false
}